module.exports = __webpack_public_path__ + "img/NL530.0ab2aae7.png";